<template>

    <transition name="delay">
        <div class="loader" v-if="loading">

            <div class="rotate">
                <svg class="circular" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
                </svg>
            </div>

        </div>
    </transition>
    
</template>

<script>
import events from '../../events/events';
import { mapState } from 'vuex';

export default
{
    name: 'Loader',

    computed: {
        ...mapState({
            loaderCount: state => state.loader.count
        })
    },

    data() {
        return {
            loading: false
        }
    },

    watch: {
        loaderCount:
        {
            handler(val)
            {
                if (val > 0 && this.loading === false)
                {
                    this.loading = true;
                }

                if (val <= 0 && this.loading === true)
                {
                    this.loading = false;
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// Loader.vue?deca9618